import { CURRENCY } from '@client/definitions/constants.js';
import {
  EVENT_PURCHASE,
  FORM_START,
  FORM_SENT,
} from '@client/definitions/tracking.js';

export const GTM = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

export const trackCustomEvent = (name, params) => {
  const data = {
    event: name,
    ...params,
  };
  GTM(data);
};

export const trackPurchase = (transaction_id, value, items, userData) => {
  GTM({
    event: EVENT_PURCHASE,
    user_data: userData,
    transaction_id,
    value,
    currency: CURRENCY,
    items: [...items],
    contents: items.map(({ item_name, quantity, price }) => ({
      id: item_name,
      item_price: price,
      quantity,
    })),
  });
};

export const trackFormStart = (formType, params) => {
  GTM({
    event: FORM_START,
    form_title: formType,
    ...params,
  });
};

export const trackFormSent = (params) => {
  GTM({
    event: FORM_SENT,
    ...params,
  });
};
